import * as React from 'react';

const SvgOfferPercentage: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2l2.226 1.693L17 3.34l1.081 2.579L20.661 7l-.354 2.774L22 12l-1.693 2.226L20.66 17l-2.579 1.081L17 20.661l-2.774-.354L12 22l-2.226-1.693L7 20.66l-1.081-2.579L3.339 17l.354-2.774L2 12l1.693-2.226L3.34 7l2.579-1.081L7 3.339l2.774.354L12 2zm2.479 3.677l1.265-.161.493 1.176.316.755.755.316 1.176.493-.161 1.265-.103.813.495.651.772 1.015-.772 1.015-.495.651.103.813.161 1.265-1.176.493-.755.316-.316.755-.493 1.176-1.265-.161-.813-.103-.651.495-1.015.772-1.015-.772-.651-.495-.813.103-1.265.161-.493-1.176-.316-.755-.755-.316-1.176-.493.161-1.265.103-.813-.495-.651L4.513 12l.772-1.015.495-.651-.103-.813-.161-1.265 1.176-.493.755-.316.316-.755.493-1.176 1.265.161.813.103.651-.495L12 4.513l1.015.772.651.495.813-.103zM9.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.5 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-6.793 1.707l7-7-1.414-1.414-7 7 1.414 1.414z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgOfferPercentage;
